const validate = (fields, showError) => {
  const invalidPathRegEx = new RegExp('[^A-Za-z0-9_-]');
  const validateEmail = (email) => {
    // eslint-disable-next-line
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };
  for (let i = 0; i < fields.length; i += 1) {
    const {
      type,
      name,
      value,
      maxLength,
      minLength,
    } = fields[i];

    if (type === 'required' && !value) {
      showError(`${name} field is required`);
      return false;
    }
    if (type === 'maxLength' && value.length > maxLength) {
      showError(`${name} field length should be less then ${maxLength}`);
      return false;
    }
    if (type === 'minLength' && value.length < minLength) {
      showError(`${name} field length should be less then ${minLength}`);
      return false;
    }
    if (type === 'email' && value && !validateEmail(value)) {
      showError(`${name} field is must be valid`);
      return false;
    }
    if (type === 'path' && value && value.match(invalidPathRegEx)) {
      showError('Path Alias should content only letters, digits and symbols -, _');
      return false;
    }
  }
  return true;
};

export default validate;



// WEBPACK FOOTER //
// ./src/helpers/validation.js